import { useMemo } from "react";
import { IFilter } from "../types";

export const useFilterQuery = (filters: IFilter) => {
  const filterQuery = useMemo(() => {
    const {
      first,
      rows,
      filter,
      filterByStatus,
      filterByTitle,
      filterByCustomerCategory,
      filterByProjectType,
      filterByScheduled,
    } = filters;
    const filterParam = filter ? `&filter=${filter}` : "";
    const filterByStatusParam = filterByStatus
      ? `&filterByStatus=${filterByStatus}`
      : "";
    const filterByCustomerCategoryParam = filterByCustomerCategory
      ? `&filterByCustomerCategory=${filterByCustomerCategory}`
      : "";

    const filterByProjectTypeParam = filterByProjectType
      ? `&filterByProjectType=${filterByProjectType}`
      : "";

    const filterByTitleParam = filterByTitle
      ? `&filterByTitle=${filterByTitle}`
      : "";

    const filterByScheduledParam = filterByScheduled
      ? `&filterByScheduled=${filterByScheduled}`
      : "";

    return `first=${first}&rows=${rows}${filterParam}${filterByStatusParam}${filterByCustomerCategoryParam}${filterByProjectTypeParam}${filterByTitleParam}${filterByScheduledParam}`;
  }, [filters]);
  return filterQuery;
};
